module.exports = __webpack_public_path__ + "assets/images/premium-features/nf-access-restriction-854a3a.png";